<div class="content card">
  <div *ngIf="showClose" class="close" (click)="closeCard()">
    <img [src]="getCloseIcon" />
  </div>
  <div class="card">
    <div class="top-content">
      <cowing-tag
        *ngIf="isOpened()"
        [text]="'coworker.home.card.open' | translate"
        [background]="'white'"
        [color]="'black'"
      ></cowing-tag>
      <cowing-tag
        *ngIf="!isOpened()"
        [text]="'coworker.home.card.close' | translate"
        [background]="'red'"
        [color]="'white'"
      ></cowing-tag>

      <cowing-tag
        *ngIf="coworking?.distance"
        [text]="coworking?.distance_text"
        [background]="'white'"
        [color]="'black'"
      ></cowing-tag>
      <span *ngIf="!coworking?.distance" class="no-location" (click)="showModal()">
        <img [src]="getLocationOffIcon" alt="" />
      </span>
    </div>

    <ng-image-slider
      [imageSize]="{ width: '100%', height: '37%', space: 0 }"
      [images]="mediaObject"
      [manageImageRatio]="'true'"
      [lazyLoading]="true"
      [imagePopup]="false"
      (imageClick)="redirectToDetails()"
      #nav
    ></ng-image-slider>


    <div class="bottom-content">
      <div class="bottom-content-body" *ngIf="!showMode">
        <div class="bottom-content-title" >
          {{ coworking?.company_name }}
        </div>
        <div class="bottom-content-text" >
          <span class="bold"
            >{{ "coworker.home.card.from" | translate }}
            {{ coworking?.min_price }} C</span
          >
          <span *ngIf="coworking?.min_price_type == 1">
            / {{ "coworker.home.card.hour" | translate }}
          </span>
          <span *ngIf="coworking?.min_price_type == 3">
            / {{ "coworker.home.card.day" | translate }}
          </span>
          <span *ngIf="coworking?.min_price_type == 4">
            / {{ "coworker.home.card.week" | translate }}
          </span>
          <span *ngIf="coworking?.min_price_type == 5">
            / {{ "coworker.home.card.month" | translate }}
          </span>

        </div>

        <cowing-button
        (event)="redirectToDetails()"
        [type]="EButtonType.RoundedNoBackground"
        [iconShow]="true"
        [iconName]="'arrowRight'"
        [label]="'coworker.booking.more-info' | translate"
        >
        </cowing-button>

      </div>
      <div class="bottom-content-body" >
        <cowing-button
          *ngIf="!showMode"
          class="content-bottom"
          [label]="'coworker.booking.title' | translate"
          (event)="goBooking()"
          [type]="EButtonType.MiniRounded"
          [iconShow]="true"
          [iconName]="'arrowRight'"
        >
        </cowing-button>
      </div>
    </div>
  </div>
</div>
